const React = require('react')

const FooterTermsAndPolicies = () => {
    return (
        <div className='footer-terms-and-policies'>
            <div className='footer-terms-and-policies-content'>
                <div className='footer-terms-and-policies-left'>
                    <p>Copyright 2021 by Vietnam Blockchain Corporation</p>
                    <p>All rights reserved</p>
                </div>
                <div className='footer-terms-and-policies-right'>
                    <a href='https://vietnamblockchain.asia/private-policy'>
                        Terms & Policies
                    </a>
                </div>
            </div>
        </div>
    )
}

module.exports = { FooterTermsAndPolicies }
